import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';
import {
    initialAmenities,
    initialReservationTypes,
    setAmenities,
    setReservationTypes,
    setPriceRange,
} from './filters-utils';

const getIsMonthly = state => state.searchRequest.monthly;
const getAllSpots = state => state.spots.data;
const getCurrentFilters = state => state.filters;
const getAllAmenities = state => state.filters.amenities;
const getAllReservationTypes = state => state.filters.reservationTypes;
const getPrice = state => state.filters.price;

export const getAmenities = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllAmenities],
    (isMonthly, spots, filters, amenities) => {
        if (!spots.length) {
            return initialAmenities;
        }

        return setAmenities({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            rateType: isMonthly ? 'monthly_rates' : 'hourly_rates',
            amenities,
        });
    }
);

export const getReservationTypes = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllReservationTypes],
    (isMonthly, spots, filters, reservationTypes) => {
        if (!spots.length || !isMonthly) {
            return initialReservationTypes;
        }

        return setReservationTypes({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            reservationTypes,
        });
    }
);

export const getPriceRange = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getPrice],
    (isMonthly, spots, filters, price) => {
        return setPriceRange({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            price,
        });
    }
);
